import "./exhibition_page.module.css"; import "./exhibition_page.module.css.json"; import "./index.js"
